import React from "react";
import classes from "./header.module.css";

const Header = () => {
  return (
    <header className={classes.header}>
      <div className={classes.container}>
        <a href="/" className={classes.logo}>
          <div className={classes.logoIcon}>₿</div>
          <div className={classes.logoText}>
            <span className={classes.logoName}>CryptoPump</span>
            <span className={classes.logoTagline}>30% daily gainers</span>
          </div>
        </a>

        <div className={classes.rightSection}>
          <div className={classes.marketStatus}>
            <div className={classes.statusDot}></div>
            <span>Live Market</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
